
export const CHANGE_ACTIVE_ROUTE = 'CHANGE_ACTIVE_ROUTE';